import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import EDITLogo from "../../assets/images/edit.png";
import editLogoSVG from "../../assets/images/edit_icon.svg";
import { params, const_var, /* initialState */ } from "./reducer";
import { /* removeComponent */ genratePrintImages, setPricingForComponent,showDoorWindowsPrompt,setPriceForCupola, updateDoorWindowPosition, ShowHideCheckout, showSaveLater, showDownloadProgressBar, /* showAlert */ } from "../../action/index.js";
import { SendBuildingDatatoServer } from "../../action/leadcustomer.action.js";
import { SendBuildingDatatoPublicServer, onQuoteSubmitApi } from "../../action/quote.action.js";
import * as cuBuilding from "./pricingReducer";
import axios from "axios";
import store from "../store/index.js";
import TWEEN from "@tweenjs/tween.js";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader";
import CSG from "../../assets/libs/three-csg";
import shutterWindowTexture from '../../assets/images/imgTextures/buildingImages/shutterWindowTexture.jpeg';
import { makeTranslucent, updateWalkinWindowlegCutPrice } from  './utils'
import { addValidation, cupolaValidation } from "../../utils/Validation.js";
import { captureBlobImages, isAllCaptured } from "../../action/orderExtras.action.js";
import { controls } from "./eventReducer.js";

let intersectedWall = null;




export const componentState = {
    updateStateAccordingtoCondition: "",
    updateNewAction: "",
    layout2DMapId: 0,
    generated2DMapId: null
};
const componentReducer = (state = componentState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "genrateBlobImage":
            action.event.preventDefault();
            const_var.checkIval = 0;
            const_var.i_g_A_y = [];
            TsCeSot("quote", "", "test");
            return {
                ...state,
                updateStateAccordingtoCondition: action + state.updateNewAction,
            };
        case "prepareTwoDMapData":
            const_var.layout2DMapId = (state.layout2DMapId + 1) % 65536;
            const_var.generated2DMapId = null;
            return {
                ...state,
                layout2DMapId: (state.layout2DMapId + 1) % 65536,
            };
        case "generatedTwoDMapData":
            const_var.generated2DMapId = action.payload;
            return {
                ...state,
                generated2DMapId: action.payload,
            };
        default:
            break;
    }
    return newState;
};

/*********************  Giorgi  ************************* */
export const loadDoorComponentOnWall = (compType, compName, wallName, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,parentOBJ, isBreezewayFrame, breezewayUniqueI, selectedCmpPosX, selectedCmpPosY, isChangePos) => {
    // console.log('giorgi- loadDoorComponentOnWall: ', {compType, compName, wallName, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,parentOBJ, isBreezewayFrame, breezewayUniqueI, selectedCmpPosX, selectedCmpPosY, isChangePos});
    let componentdimension = (is_edit != undefined) ? componentsize.name.split("x") : componentsize.split("x");
    const width = (compType == "garage_door" || compType == "garage_door_frameout") ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12;
    const height = (compType == "garage_door" || compType == "garage_door_frameout") ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;

    const validationVariable = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey });
    // console.log('giorgi- loadDoorComponentOnWall _ validationVariable: ', validationVariable);
    let isAdd = validationVariable.isAdd;
    let positionX = validationVariable.positionX;
    let positionY = validationVariable.positionY;
    const minLimitX = validationVariable.minLimitX;
    const maxLimitX = validationVariable.maxLimitX;
    const newArray = validationVariable.newArray;

    if (isChangePos === false && (selectedCmpPosX !== undefined && selectedCmpPosY !== undefined)) {
        positionX = selectedCmpPosX;
        if (compType === "window" || compType === "window_frameout") positionY = selectedCmpPosY;
    }
    if (is_edit != undefined ) {
        positionX = entry_position.positionX;
        if((compType === "window" || compType === "window_frameout")){
            positionY = entry_position.positionY;
        }

    const overlapped = const_var.newDoorsArray.filter((door) => door.userData.wallName == wallName).find((item) => {
            if (((item.positionX + item.width / 2) >= (positionX - width / 2)) && ((item.positionX - item.width / 2) <= (positionX + width / 2)) &&
               ((item.positionY + item.height / 2) >= (positionY - height / 2)) && ((item.positionY - item.height / 2) <= (positionY + height / 2))) {
                  return item;
            }  
      })

    if (overlapped) isAdd = false;

        const_var.sum++;
    }
    if(isAdd==false)
    {
        store.dispatch(showDoorWindowsPrompt(compType, compName, width, height, wallName));
        const_var.checkDoorIsadded = false;
    }
    if (isAdd) {
        let tempArray = [...newArray];
        const newUniqueId = const_var.newDoorsArray.length > 0 ? const_var.newDoorsArray[const_var.newDoorsArray.length - 1].uniqueId + 1 : 0;
        // console.log(params.g_d_c,"params.g_d_c")
        const wallComponent = {
            uniqueId: newUniqueId,
            parent_array_key: parentkey,
            child_array_key: childkey,
            nested_array_key: nestedkey,
            size: (is_edit!=undefined)?componentsize.name:componentsize,
            // cutLegCount: 0,
            actual_val: width + "x" + height,
            DoorObj: { 
                "trimkit": componentsize.entry_trim_kit!=undefined?componentsize.entry_trim_kit:params.trimkit, 
                "chain_hoist": componentsize.entry_chain_hoist!=undefined?componentsize.entry_chain_hoist:params.chain_hoist, 
                "header_seal": componentsize.entry_header_seal!=undefined?componentsize.entry_header_seal:params.header_seal, 
                "certified_door": componentsize.entry_certified!=undefined?componentsize.entry_certified:params.certified_door, 
                "entry_note": componentsize.entry_note!=undefined?componentsize.entry_note:params.extra_notes, 
                "garage_door_color": (is_edit!=undefined && componentsize.entry_garageDoor_color_Obj!=undefined)?componentsize.garage_door_color.replace("0x","#"):(params.g_d_c.includes("0x"))?params.g_d_c.replace("0x","#"):'#ffffff', 
                "automatic_openers": componentsize.entry_automatic_openers!=undefined?componentsize.entry_automatic_openers:params.entry_automatic_openers 
            },
            userData: {
                compType,
                wallName,
                uniqueId: newUniqueId,
                compName,
                isBreezewayFrameOut: false,
                cuttingFeatureAvailable: true,
            },
            doorColor: parentkey == "Walk" ? "#ffffff": (is_edit!=undefined && componentsize.entry_garageDoor_color_Obj!=undefined)?componentsize.garage_door_color.replace("0x","#"):(params.g_d_c.includes("0x"))?params.g_d_c.replace("0x","#"):'#ffffff', 
            width,
            height,
            positionX,
            positionY,
            is_edit,
            parentOBJ, 
            entry_position,
            entry_rotation,
            isBreezewayFrame, 
            breezewayUniqueI,
            isCustomSizeChange: false,
            minLimitX,
            maxLimitX,
            entryNoteData: '',
            position: {positionX, positionY},
            name: compName + newUniqueId 
        }

        tempArray.push(wallComponent);
        
        const_var.doorUniqueId = newUniqueId;
        const_var.newDoorsArray = tempArray;

        var kk = 0;
        var kd = 0;
        var kw = 0;
        let calQuantity = 0;
        let chkCustomDoor = undefined;
        const isBreezewayFrameOut = ((isBreezewayFrame !== undefined && isBreezewayFrame == 'isBreezewayFrame'));
        let wallCheckForEnd = false, wallCheckForSide = false;

        if(const_var.entry_wall_location[wallName].includes('end')==true  && const_var.entry_wall_location[wallName] != "rfend" && const_var.entry_wall_location[wallName] != "lfend" )
        {
            wallCheckForEnd = true;
        }

        if(const_var.entry_wall_location[wallName].includes('side')==true  || const_var.entry_wall_location[wallName] == "rfend" || const_var.entry_wall_location[wallName] == "lfend")
        {
            wallCheckForSide = true;
        }
        
        if (compType == "window" || compType == "window_frameout") {
            kw++;
            calQuantity = kw;
        }

        if (compType == "walkin" || compType == "walkin_frameout") {
            kd++;
            calQuantity = kd;
        }


        if (is_edit != undefined) {
            let currentObjData = componentsize;
            let doorAddOnsObj = {};
            let doornewType = "";
            if (currentObjData.child_array_key == "overhead_door_door") {
                Object.keys(currentObjData).map((e) => {
                    if (e.includes("add_on_options"))  {
                        doorAddOnsObj[e] = currentObjData[e];
                    }
                })
                
            }

            
            
            if (currentObjData.entry_motor) {
                 const motors = currentObjData.entry_size.door_add_ons?.filter((e) => e.door == "motor");
                if(motors && motors.length > 0) {
                    const motor = motors[0].category.filter((e) => e.category == currentObjData.entry_motor_name);
                    if (motor.length == 0) {
                        if(motors[0].category.length > 0) {
                            currentObjData.entry_motor_name = motors[0].category[0].category;
                            currentObjData.entry_motor_price = motors[0].category[0].cost;
                        }else {
                            currentObjData.entry_motor = false;
                        }
                    }
                } else {
                    currentObjData.entry_motor = false;
                }
            }
            if(currentObjData.child_array_key=="overhead_door_door")
            {
                 const wOPtion = currentObjData.entry_size.door_add_ons?.filter((e) => e.door == 'window_option');
                if (wOPtion && wOPtion.length > 0) {
                    const doorName = compName.replace("overhead_door_door_", '');
                    doornewType = wOPtion[0].category.find((item) => item.category.split(' ').join('_').toLowerCase() == doorName);
                    if(doornewType!='')
                    {
                        doorAddOnsObj.entry_overhead_type_name = (doornewType!=undefined)?doornewType.category:'';
                        doorAddOnsObj.entry_overhead_type_price = (doornewType!=undefined)?doornewType.cost:'';
                    }
                }
            }
            
            if (parentkey == "Garage" || parentkey == "Garage_Frameout") {

                if ((params.m_s_n == 3 || params.m_s_n == 9) && currentObjData.entry_header_seal == true && currentObjData.entry_automatic_openers == true) {
                    if (const_var.isFromCompare) {
                        currentObjData.entry_header_seal = false;
                        wallComponent.DoorObj.header_seal = false;
                    }
                }
                
                if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                {
                    if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                    {
                        wallComponent.DoorObj.installation_is_end_wall = currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'';
                    }
                    if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                    {
                        wallComponent.DoorObj.installation_is_side_wall = currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'';
                    }
                }
                let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
                if(newDoorData.length>0 && currentObjData.door_type == "overhead_door_door")
                {
                    newDoorData[0].userData.compName = compName;
                }
                kk++;
                calQuantity = kk;
                const_var.entry_points.push(Object.assign({ "entry_motor_name": currentObjData.entry_motor_name, "entry_motor": currentObjData.entry_motor, "entry_is_motor": currentObjData.entry_is_motor, "entry_motor_price": currentObjData.entry_motor_price, "entry_insulated": currentObjData.entry_insulated, "entry_is_insulated": currentObjData.entry_is_insulated, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'entry_dimension_height': height, 'entry_trim_kit_price': currentObjData.entry_trim_kit_price,'entry_is_trim_kit': currentObjData.entry_is_trim_kit, 'entry_dimension_width': width, 'uniqueId': newUniqueId, 'entry_price': currentObjData.entry_price, 'entry_size': is_edit, 'name': currentObjData.name, "entry_note": currentObjData.entry_note, "garage_door_color": currentObjData.garage_door_color, "entry_trim_kit": currentObjData.entry_trim_kit, "entry_header_seal": currentObjData.entry_header_seal, "entry_certified": currentObjData.entry_certified, "entry_chain_hoist": currentObjData.entry_chain_hoist, "entry_is_header_seal": currentObjData.entry_header_seal, "entry_is_certified": currentObjData.entry_certified, "entry_is_chain_hoist": currentObjData.entry_chain_hoist, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_chain_hoist_price': currentObjData.entry_chain_hoist_price, 'entry_automatic_openers_price': currentObjData.entry_automatic_openers_price, 'entry_header_seal_price': currentObjData.entry_header_seal_price, 'entry_component_location': const_var.entry_wall_location[wallName], "entry_automatic_openers": currentObjData.entry_automatic_openers, "entry_is_automatic_openers": currentObjData.entry_automatic_openers, 'entry_garageDoor_color_Obj': currentObjData.entry_garageDoor_color_Obj != undefined ? currentObjData.entry_garageDoor_color_Obj : const_var.garageDoorColor[params.g_d_c_id], 'entry_garageDoor_color_price': currentObjData.entry_garageDoor_color_price!=undefined?currentObjData.entry_garageDoor_color_price:const_var.garageDoorColor[params.g_d_c_id].cost, 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, 'entry_doorNewType': currentObjData.entry_doorNewType,'installation_is_end_wall':currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'','installation_is_side_wall':currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'','installation_end_wall_fee':currentObjData.installation_end_wall_fee!=undefined && wallCheckForEnd==true?currentObjData.installation_end_wall_fee:0,'installation_side_wall_fee':currentObjData.installation_side_wall_fee!=undefined && wallCheckForSide==true?currentObjData.installation_side_wall_fee:0,'uniqueName':compName+newUniqueId,'overheadDoorSum':currentObjData.overheadDoorSum!=undefined?currentObjData.overheadDoorSum:undefined, 'is_breezeway_frameout':isBreezewayFrameOut ? true : false,}, doorAddOnsObj));
                // if (((wallComponent.name.includes("door" + newUniqueId) == true)||(wallComponent.name.includes("overhead_door_door") == true && newUniqueId == wallComponent.uniqueId)) && parentkey == "Garage") {
                //     if (wallComponent.children[1] != undefined) {
                //         if(wallComponent.name.includes("overhead_door_door")){
                //             wallComponent.children.forEach((child)=>{
                //                 if(child.name.includes("door")) child.material.color.setHex(currentObjData.garage_door_color);
                //             });
                //         }else{
                //             wallComponent.children[1].material.color.setHex(currentObjData.garage_door_color);
                //         }
                //     }
                // }
                // if(wallComponent.name.includes("sectional_with_window_door") == true)
                // {
                //     let index = wallComponent.children.findIndex(data=>data.name.includes("Plane")==true );
                //     if(wallComponent.children[index]!=undefined)
                //     {
                //         wallComponent.children[index].material.color.setHex( currentObjData.garage_door_color );
                //     }
                // }

            } else {
                let tmpObj = {"entry_dimension_width": width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': currentObjData.entry_price, 'entry_size': is_edit, 'name': currentObjData.name, "entry_note": currentObjData.entry_note, "garage_door_color": params.g_d_c, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, 'entry_doorNewType': currentObjData.entry_doorNewType ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,
                'is_price_updated': currentObjData.is_price_updated
                }
                let tmpUpdtedObj = currentObjData.legCutFee != undefined ? {...tmpObj, legCutFee: currentObjData.legCutFee} : tmpObj
                const_var.entry_points.push(tmpUpdtedObj);
            }

            if (is_edit != undefined && const_var.sum == const_var.hodldEditBuildingData?.entry_points.length) {
                store.dispatch(setPricingForComponent(true, newUniqueId,const_var.entry_points.length-1,'',true));
            }
            // console.log(parentOBJ,"parentOBJ",const_var.entry_points)
        } else {

            let currentObjData = !isBreezewayFrameOut && const_var.newComponentArray[parentkey][childkey][nestedkey]!=undefined ? const_var.newComponentArray[parentkey][childkey][nestedkey]["Size"][componentsize] : undefined;
            // console.log(currentObjData,"currentObjDatacurrentObjDatacurrentObjDatacurrentObjData");
            chkCustomDoor = undefined;
            if (currentObjData == undefined) {
                const_var.newCustomSizesArray = {
                    "45_degree_angle": 0,
                    certified_cost: 0,
                    chain_hoist: 0,
                    color_cost: 0,
                    cost: 0,
                    header_bar: 0,
                    header_seal: 0,
                    height: 8,
                    id: 55374,
                    is_certified: 0,
                    is_chain_hoist: 0,
                    is_header_bar: 0,
                    is_header_seal: 0,
                    map_id: 13,
                    name: "8x8",
                    side_cost: 0,
                    vertical_side_cost: 0,
                    width: 8,
                };
                chkCustomDoor = "Custom Size";
                currentObjData = const_var.newCustomSizesArray;
                currentObjData.name = componentsize;
                currentObjData.width = componentsize.split("x")[0];
                currentObjData.height = componentsize.split("x")[1];
            }
            let trimPrice = 0;
            let componentPrice = 0;
            let verticalOnSideCost = (currentObjData.vertical_side_cost) ? currentObjData.vertical_side_cost : 0;
            let finalComponentPrice = const_var.entry_wall_location[wallName].includes('side');
            
            if (parentkey == "Garage_Frameout") {
                trimPrice = (currentObjData.dutch_cost != undefined && currentObjData.dutch_cost_side != undefined) ? (finalComponentPrice == true) ? currentObjData.dutch_cost_side : currentObjData.dutch_cost : 0;
            } else {
                trimPrice = (currentObjData['45_degree_angle'] != undefined) ? currentObjData['45_degree_angle'] : 0;
            }

            if (parentkey == "Garage_Frameout") {
                componentPrice = (finalComponentPrice == true) ? currentObjData.on_side : currentObjData.on_end;
            }
            if (parentkey == "Garage") {
                componentPrice = (finalComponentPrice == true) ? currentObjData.side_cost + currentObjData.cost : currentObjData.cost;
            }
            if (parentkey == "Walk") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ? verticalOnSideCost + currentObjData.cost : currentObjData.cost : currentObjData.cost;
            }
            if (parentkey == "Walk_Frameout") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ?  currentObjData.frameout_cost_side:currentObjData.frameout_cost_side : currentObjData.frameout_cost_end;
            }
            if (parentkey == "Windows") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ?  verticalOnSideCost + currentObjData.cost : currentObjData.cost : currentObjData.cost;
            }
            if (parentkey == "Windows_Frameout") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ? currentObjData.vertical_side_cost + currentObjData.frameout_cost_side : currentObjData.frameout_cost_side : currentObjData.frameout_cost_end;
            }
            if (isNaN((componentPrice)) == true) {
                componentPrice = 0;
            }
            if(parentkey == "Garage_Frameout" )
            {
                currentObjData.name = "Custom";
            }
            let is_trim_kit = true;
            if(currentObjData['is_45_degree_angle']!=undefined)
            {
                is_trim_kit = currentObjData['is_45_degree_angle']==1?true:false;
            }
            if(chkCustomDoor=="Custom Size" && currentObjData['is_45_degree_angle']==undefined)
            {
                is_trim_kit = true;
            }
            
            let is_insulated = false;
            let insulatedPrice = 0;
            let doorAddOnsObj = {};
            let is_motor = false;
            let motorPrice = 0;
            let motorName = "";
            let doornewType = "";
            if (currentObjData.door_type == "overhead_door_door") {
                const wOPtion = currentObjData.door_add_ons.filter((e) => e.door == 'window_option');
                const doorName = compName.replace("overhead_door_door_", '');
                doornewType = wOPtion[0].category.find((item) => item.category.split(' ').join('_').toLowerCase() == doorName);
                let insulatedObj = currentObjData.door_add_ons.filter((e) => e.door == "insulated");
                if (insulatedObj.length > 0) {
                    is_insulated = insulatedObj[0].category[0].is_cost == '1'? true: false;
                    insulatedPrice = parseFloat(insulatedObj[0].category[0].cost);
                    if ( parentkey =="Garage" && insulatedObj[0].category[0].is_cost == 2){
                        params.insulated = true;
                    }
                }
                currentObjData.door_add_ons.filter((e) => {
                    if (e.door == "motor") {
                        is_motor  = e.is_cost == '1';
                        motorName = e.category[0].category;
                        motorPrice = e.category[0].cost;

                        if ( parentkey =="Garage" && e.category[0].is_cost == 2){
                            params.motor = true;
                        }
                    }
                });

                let addOnOptions = currentObjData.door_add_ons.find((e) => e.door == "add_on_options");
                addOnOptions?.category.map((item) => {
                    let addObj = {};
                    
                    if (parentkey =="Garage" && item.is_cost == 2){
                        params[item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = true;
                    }
                    addObj["entry_is_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = item.is_cost == 1? true: false;
                    addObj["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"] = parentOBJ!=undefined && parentOBJ["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"] != undefined ? parentOBJ["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"]: item.cost;
                    addObj["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = item.category == "Frame Out"? true: params[item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door]
                
                    return addObj;                                                                                                                                                                  
                                                                                                                                                                                         
                }).map((e) => doorAddOnsObj = {...doorAddOnsObj, ...e})
                if(doornewType!='')
                {
                    doorAddOnsObj.entry_overhead_type_name = (doornewType!=undefined)?doornewType.category:'';
                    doorAddOnsObj.entry_overhead_type_price = (doornewType!=undefined)?doornewType.cost:'';
                }
            }

            if ( parentkey =="Garage"){
                if(currentObjData.is_chain_hoist == 2 ) {
                    params.chain_hoist = true;
                }
                if(currentObjData.is_header_seal == 2) {
                    params.header_seal = true;
                }
                if( currentObjData.is_certified == 2 ) {
                    params.certified_door = true;
                }
                if(currentObjData.is_automatic_openers == 2 ) {
                    params.automatic_openers = true;
                }
                if (params.insulated == true) {
                        componentPrice =(parseFloat(componentPrice) + parseFloat(insulatedPrice)).toFixed(2);
                }
                if (params.certified_door == true && currentObjData.certified_cost!=0) {
                        componentPrice =(parseFloat(componentPrice) + parseFloat(currentObjData.certified_cost)).toFixed(2);
                }
                
            }
            let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
            if(newDoorData.length>0 && currentObjData.door_type == "overhead_door_door")
            {
                newDoorData[0].userData.compName = compName;
            }
            if(parentOBJ!=undefined)
            {
                componentPrice = parentOBJ.entry_price;

                if(parentOBJ.entry_trim_kit_price!=undefined)
                {
                    trimPrice = parentOBJ.entry_trim_kit_price;
                }

                if (parentkey == "Garage" || parentkey == "Garage_Frameout") {
                    if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                    {
                        if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_end_wall = parentOBJ.installation_is_end_wall!=undefined && wallCheckForEnd==true?parentOBJ.installation_is_end_wall:'';
                        }
                        if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_side_wall = parentOBJ.installation_is_side_wall!=undefined && wallCheckForSide==true?parentOBJ.installation_is_side_wall:'';
                        }
                    }
                    // console.log(params.g_d_c_id,"params.g_d_c_id",params.g_d_c_id)
                    let doorColorPrice = (const_var.garageDoorColor[params.g_d_c_id].percentage_of_cost > 0) ? componentPrice * const_var.garageDoorColor[params.g_d_c_id].cost / 100 : const_var.garageDoorColor[params.g_d_c_id].cost;
                    // console.log(params.g_d_c_id,doorColorPrice,"params.g_d_c_id",params.g_d_c_id)
                    const_var.entry_points.push(Object.assign({"entry_motor_name": parentOBJ.entry_motor_name, "entry_motor": parentOBJ.entry_motor, "entry_is_motor": parentOBJ.entry_is_motor, "entry_motor_price": parentOBJ.entry_motor_price, "entry_insulated": params.insulated, "entry_is_insulated": is_insulated, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'entry_dimension_height': height, 'entry_trim_kit_price': trimPrice,'entry_is_trim_kit': is_trim_kit, 'entry_dimension_width': width, 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "garage_door_color": params.g_d_c, "entry_trim_kit": params.trimkit, "entry_header_seal": params.header_seal, "entry_certified": params.certified_door, "entry_chain_hoist": params.chain_hoist, "entry_is_header_seal": params.header_seal, "entry_is_certified": params.certified_door, "entry_is_chain_hoist": params.chain_hoist, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_chain_hoist_price': parentOBJ.entry_chain_hoist_price, 'entry_automatic_openers_price': parentOBJ.entry_automatic_openers_price, 'entry_header_seal_price': parentOBJ.entry_header_seal_price, 'entry_component_location': const_var.entry_wall_location[wallName], "entry_automatic_openers": params.automatic_openers, "entry_is_automatic_openers": params.automatic_openers, 'entry_garageDoor_color_Obj': const_var.garageDoorColor[params.g_d_c_id], 'entry_garageDoor_color_price': doorColorPrice, 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor,'installation_is_end_wall':parentOBJ.installation_is_end_wall!=undefined && wallCheckForEnd==true?parentOBJ.installation_is_end_wall:'','installation_is_side_wall':parentOBJ.installation_is_side_wall!=undefined && wallCheckForSide==true?parentOBJ.installation_is_side_wall:'','installation_end_wall_fee':parentOBJ.installation_end_wall_fee!=undefined && wallCheckForEnd==true?parentOBJ.installation_end_wall_fee:0,'installation_side_wall_fee':parentOBJ.installation_side_wall_fee!=undefined && wallCheckForSide==true?parentOBJ.installation_side_wall_fee:0  ,'uniqueName':compName+newUniqueId,'overheadDoorSum':parentOBJ.overheadDoorSum!=undefined?parentOBJ.overheadDoorSum:undefined, 'is_breezeway_frameout':isBreezewayFrameOut ? true: false,}, doorAddOnsObj));
                } else {
                    const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,'is_price_updated':parentOBJ.is_price_updated || false});
                }
                // console.log(params.g_d_c,parentOBJ,"parentOBJ",const_var.entry_points)
            }else{
                let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
                if(newDoorData.length>0 && currentObjData.door_type == "overhead_door_door")
                {
                    newDoorData[0].userData.compName = compName;
                }
                let doorColorPrice = (const_var.garageDoorColor[params.g_d_c_id].percentage_of_cost > 0) ? componentPrice * const_var.garageDoorColor[params.g_d_c_id].cost / 100 : const_var.garageDoorColor[params.g_d_c_id].cost;
                    if (parentkey == "Garage" || parentkey == "Garage_Frameout") {
                        if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                        {
                            if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                            {
                                wallComponent.DoorObj.installation_is_end_wall = currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'';
                            }
                            if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                            {
                                wallComponent.DoorObj.installation_is_side_wall = currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'';
                            }
                        }

                    const_var.entry_points.push(Object.assign({"entry_motor_name": motorName, "entry_motor": params.motor, "entry_is_motor": is_motor, "entry_motor_price": motorPrice, "entry_insulated": params.insulated, "entry_is_insulated": is_insulated,"parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'entry_dimension_height': height, 'entry_trim_kit_price': trimPrice,'entry_is_trim_kit': is_trim_kit, 'entry_dimension_width': width, 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "garage_door_color": params.g_d_c, "entry_trim_kit": params.trimkit, "entry_header_seal": params.header_seal, "entry_certified": params.certified_door, "entry_chain_hoist": params.chain_hoist, "entry_is_header_seal": params.header_seal, "entry_is_certified": params.certified_door, "entry_is_chain_hoist": params.chain_hoist, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_chain_hoist_price': currentObjData.chain_hoist, 'entry_automatic_openers_price': currentObjData.automatic_openers, 'entry_header_seal_price': currentObjData.header_seal, 'entry_component_location': const_var.entry_wall_location[wallName], "entry_automatic_openers": params.automatic_openers, "entry_is_automatic_openers": params.automatic_openers, 'entry_garageDoor_color_Obj': const_var.garageDoorColor[params.g_d_c_id], 'entry_garageDoor_color_price': doorColorPrice, 'component_name': compName,"component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor,'installation_is_end_wall':currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'','installation_is_side_wall':currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'','installation_end_wall_fee':currentObjData.installation_end_wall_fee!=undefined && wallCheckForEnd==true?currentObjData.installation_end_wall_fee:0,'installation_side_wall_fee':currentObjData.installation_side_wall_fee!=undefined && wallCheckForSide==true?currentObjData.installation_side_wall_fee:0   ,'uniqueName':compName+newUniqueId,'overheadDoorSum':currentObjData.overheadDoorSum!=undefined?currentObjData.overheadDoorSum:undefined,'is_breezeway_frameout':isBreezewayFrameOut ? true: false,}, doorAddOnsObj));
                } else {
                    const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,});
                }
                // console.log(parentOBJ,"parentOBJ",const_var.entry_points)
            }
            //store.dispatch(prepareTwoDMapData())
            store.dispatch(setPricingForComponent(true, newUniqueId,const_var.entry_points.length-1));
            
        }
        
    } else {
        //store.dispatch(showDoorWindowsPrompt(compType, compName, width, height, wallName));
        // const_var.isShowAlert = !const_var.isShowAlert;
        // const_var.alertUsedFor = 'noSpaceAvailableOnWall';
    }
    // console.log("parentOBJ",const_var.entry_points)
    // const gltfLoader = new GLTFLoader();
    // const baseUrl = process.env.REACT_APP_BASE_URL;
    // try {
    //     const gltf = await gltfLoader.loadAsync(`${baseUrl}/assets/glbModels/handle_sphere.glb`);
    //     const_var.loadGltObj = gltf.scene?.children[0]?.children[0];

    //     console.log("Loaded GLTF Object:", const_var.loadGltObj);
    // } catch (error) {
    //     console.error('Error loading GLTF model:', error);
    // }
    // const_var.checkDoorIsadded = false;
    document.querySelector('body').classList.remove('active-modal-loader');
}

export const removeComponentFromWall = (uniqueId) => {
    const restArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== uniqueId);
    const_var.newDoorsArray = restArray;

    const restEntrypoints = const_var.entry_points.filter((item) => item.uniqueId !== uniqueId)
    const_var.entry_points = restEntrypoints;
    cuBuilding.cP();
}
/*********************  Giorgi  ************************* */

function setRaycaster(event) {
    const rect = const_var.renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector3();
    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = 2 * -((event.clientY - rect.top) / rect.height) + 1;

    const_var.raycaster.setFromCamera(mouse, const_var.camera);
}

export function getIntersectedObject(event, objects) {
    setRaycaster(event);
    return const_var.raycaster.intersectObject(objects);
}

export function getIntersectedObjects(event, arr) {
    setRaycaster(event);
    return const_var.raycaster.intersectObjects(arr, true);
}

export function updateDoorIconsPos(state, doorWallName, currentId) {
    const rect = const_var.renderer.domElement.getBoundingClientRect();
    const doorWindowIconsPos = [];
    // console.log(const_var.b_s_c_n,"doorUniqueId")
    state.const_var.newDoorsArray.forEach((door) => {
        if (door.userData.editIconPos && door.userData.wallName === doorWallName) {
            let vector = door.localToWorld(door.userData.editIconPos.clone());
            vector.project(state.const_var.camera);
            vector.x = (1 + vector.x) / 2 * rect.width;
            vector.y = (1 - vector.y) / 2 * rect.height;          
            doorWindowIconsPos.push({ uniqueId: door.uniqueId, display: currentId === door.uniqueId ? 'flex' : 'none', top: `${Math.round(vector.y)}px`, left: `${Math.round(vector.x)}px` });
        }
    })


    return doorWindowIconsPos;
}
export function updateCupolaEditIconsPos(state, cupolaName, currentId) {
    const rect = const_var.renderer.domElement.getBoundingClientRect();
    const cupolaEditIconsPos = [];
    state.const_var.cupolas.forEach((cupola) => {
        if (cupola.userData.editIconPos && cupola.name === cupolaName) {
           let vector = cupola.localToWorld(cupola.userData.editIconPos.clone());
           vector.project(state.const_var.camera);
           vector.x = (1 + vector.x) / 2 * rect.width;
           vector.y = (1 - vector.y) / 2 * rect.height;
           cupolaEditIconsPos.push({ uniqueId: cupola.userData.uniqueId, display: currentId === cupola.userData.uniqueId ? 'flex' : 'none', top: `${Math.round(vector.y)}px`, left: `${Math.round(vector.x)}px` });
        }
    })
    return cupolaEditIconsPos;
}
export const bBmFd = (Val) => {
    if (const_var.c_h_d_M_l === false) {
        const_var.isShowDoorwindowmobile = true;
        const_var.c_h_d_M_l = true;
        return false;
    }
};
export const wallnameBySec = {
    c_b_f_w: "center",
    c_b_l_w: "center",
    c_b_r_w: "center",
    c_b_b_w: "center",
    F_S_L_R_W: "center",
    c_b_f_s_w: "center",
    c_b_l_s_w: "center",
    c_b_r_s_w: "center",
    c_b_f_s_l_w: "center",
    c_b_f_s_r_w: "center",
    c_b_f_s_b_w: "center",
    c_b_l_s_f_w: "center",
    c_b_l_s_b_w: "center",
    c_b_l_s_r_w: "center",
    c_b_r_s_f_w: "center",
    c_b_r_s_b_w: "center",
    c_b_r_s_l_w: "center",
    L_S_F_W_VT: "center",
    L_S_F_2W_VT: "center",
    L_S_B_W_VT: "center",
    L_S_B_2W_VT: "center",
    R_S_F_W_VT: "center",
    R_S_F_2W_VT: "center",
    R_S_B_W_VT: "center",
    R_S_B_2W_VT: "center",

    L_L_F_W: "leftlean",
    L_L_B_W: "leftlean",
    L_L_L_W: "leftlean",
    L_L_L_S_W: "leftlean",
    L_L_R_S_W: "leftlean",
    L_L_F_S_W: "leftlean",
    
    G_L_L_R_W: "leftlean",
    G_L_L_L_W: "leftlean",
    G_L_L_F_W: "leftlean",
    G_L_L_B_W: "leftlean",
    G_L_L_B_S_F_W: "leftlean",

    R_L_R_S_W: "rightlean",
    R_L_L_S_W: "rightlean",
    R_L_F_S_W: "rightlean",
    R_L_F_W: "rightlean",
    R_L_B_W: "rightlean",
    R_L_R_W: "rightlean",
    G_R_L_R_W: "rightlean",
    G_R_L_L_W: "rightlean",
    G_R_L_F_W: "rightlean",
    G_R_L_B_W: "rightlean",
    G_R_L_B_S_F_W: "rightlean",

    F_L_L_W: "frontlean",
    F_L_R_W: "frontlean",
    F_L_F_W: "frontlean",
    F_L_F_S_W: "frontlean",
    F_L_B_S_W: "frontlean",
    F_L_R_S_W: "frontlean",

    B_L_S_W: "backlean",
    B_L_B_W: "backlean",
    B_L_F_W: "backlean",
    B_L_F_S_W: "backlean",
    B_L_B_S_W: "backlean",
    B_L_L_S_W: "backlean",

}

export const cameraFocusOnWall = (store, wall) => {
    let obj
    // center building storage wall
    if (wall === 'c_b_l_s_w') obj = const_var.scene.getObjectByName('c_b_l_w');
    else if (wall === 'c_b_r_s_w') obj = const_var.scene.getObjectByName('c_b_r_w');
    else if (wall === 'c_b_l_s_f_w') obj = const_var.scene.getObjectByName('c_b_f_w');
    else if (wall === 'c_b_l_s_b_w') obj = const_var.scene.getObjectByName('c_b_b_w');
    else if (wall === 'c_b_r_s_f_w') obj = const_var.scene.getObjectByName('c_b_f_w');
    else if (wall === 'c_b_r_s_b_w') obj = const_var.scene.getObjectByName('c_b_b_w');
    // lean storage wall
    else if (wall === 'F_L_F_S_W') obj = const_var.scene.getObjectByName('F_L_F_W');
    else if (wall === 'L_L_L_S_W') obj = const_var.scene.getObjectByName('L_L_L_W');
    else if (wall === 'R_L_R_S_W') obj = const_var.scene.getObjectByName('R_L_R_W');
    else if (wall === 'B_L_F_S_W') obj = const_var.scene.getObjectByName('B_L_S_W');
    else obj = const_var.scene.getObjectByName(wall);


    let x = 0;
    let y = params.p_h / 2;
    let z = 0;
    let d = 30;
    const fvalue = 4.51/(window.innerWidth / window.innerHeight);

    const_var.controls.target.copy({x: x, y: y, z: z});
    // console.log(store,wall,"sdfsdf")
    switch (wall) {
        case "c_b_f_w":
            if (store.isFullyEnclosedCheckedForFrontLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: x, y, z: params.p_d / 2 + (fvalue * params.p_w) }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            } else {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: x, y, z: params.p_d / 2 + (fvalue * params.p_w) }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        case "c_b_b_w":
            if (store.isFullyEnclosedCheckedForBackLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: -params.p_d / 2 - (fvalue * params.p_w) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: -params.p_d / 2 - (fvalue * params.p_w) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        case "c_b_l_w":
            if (store.isFullyEnclosedCheckedForLeftLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: -params.p_w / 2 - (fvalue * params.p_d), y, z }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            } else {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: -params.p_w / 2 - (fvalue * params.p_d), y, z }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;
        case "c_b_r_w":
            if (store.isFullyEnclosedCheckedForRightLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + (fvalue * params.p_d), y, z }, 1000).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + (fvalue * params.p_d), y, z }, 1000).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            /* if (params.add_right_lean === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: x + d, y, z }, 1000).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: x + params.leanR_p_w - 1, y, z }, 1000).start();
            }*/
            break;
        // Free standing Lean-to Right Wall
        case "F_S_L_R_W":
            if (store.isFullyEnclosedCheckedForRightLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + d, y, z }, 1000).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w - 1, y, z }, 1000).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building left storage front wall
        case "c_b_l_s_f_w":
            if (store.isFullyEnclosedCheckedForFrontLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w - params.cB_addStorage_left)/2, y, z: params.p_d / 2 + d }, 1000).start()
            } else {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: -(params.p_w - params.cB_addStorage_left)/2, y, z: params.p_d / 2 + params.leanF_p_w - 1 }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building left storage back wall
        case "c_b_l_s_b_w":
            if (store.isFullyEnclosedCheckedForBackLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w - params.cB_addStorage_left)/2, y, z: -params.p_d / 2 - d }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w - params.cB_addStorage_left)/2, y, z: -params.p_d / 2 - params.leanB_p_w + 1 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building left storage right wall
        case "c_b_l_s_r_w":
            // new TWEEN.Tween(const_var.camera.position).to({x: params.p_w/2 - 1, y, z}, 1000).start();
            new TWEEN.Tween(const_var.camera.position).to({ x: - params.p_w / 2 + Number(params.cB_addStorage_left) + (fvalue * params.p_d), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building right storage front wall
        case "c_b_r_s_f_w":
            if (store.isFullyEnclosedCheckedForFrontLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w - params.cB_addStorage_left)/2, y, z: params.p_d / 2 + d }, 1000).start()
            } else {
                new TWEEN.Tween(const_var.camera.position)
                    .to({ x: (params.p_w - params.cB_addStorage_left)/2, y, z: params.p_d / 2 + d }, 1000)
                    .easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building right storage back wall
        case "c_b_r_s_b_w":
            if (store.isFullyEnclosedCheckedForBackLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w - params.cB_addStorage_left)/2, y, z: -params.p_d / 2 - d }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w - params.cB_addStorage_left)/2, y, z: -params.p_d / 2 - d }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building right storage left wall
        case "c_b_r_s_l_w":
            // new TWEEN.Tween(const_var.camera.position).to({x: -params.p_w/2 + 1, y, z}, 1000).start()
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 - params.cB_addStorage_right - (fvalue * params.p_d), y, z }, 1000).start()
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building back storage front wall
        case "c_b_f_s_w":
            if (params.cB_addStorage_check_front) new TWEEN.Tween(const_var.camera.position).to({ x, y, z: params.p_d / 2 - Number(params.cB_addStorage_front)/2 + (fvalue * params.p_w)}, 1000).start()
            else new TWEEN.Tween(const_var.camera.position).to({ x, y, z: params.p_d / 2 + (fvalue * params.p_w) }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building back storage left wall
        case "c_b_l_s_w":
            if (store.isFullyEnclosedCheckedForLeftLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - (fvalue * params.p_u_t), y, z: -(params.p_d - params.p_u_t)/2 }, 1000).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - params.lean_p_w + 1, y, z: -(params.p_d - params.p_u_t)/2 }, 1000).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building back storage right wall
        case "c_b_r_s_w":
            if (store.isFullyEnclosedCheckedForRightLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + (fvalue * params.p_u_t), y, z: -(params.p_d - params.p_u_t)/2 }, 1000).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w - 1, y, z: -(params.p_d - params.p_u_t)/2 }, 1000).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building front storage left wall
        case "c_b_f_s_l_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x - d, y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building front storage right wall
        case "c_b_f_s_r_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x + d, y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building front storage back wall
        case "c_b_f_s_b_w":
            new TWEEN.Tween(const_var.camera.position).to({ x, y, z: -params.p_d / 2 + Number(params.p_u_t) / 2}, 1000).start()
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;
        //Left lean side wall
        case "L_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2) - params.lean_p_w - (fvalue * params.lean_p_d * 2), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Left lean front wall
        case "L_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w)/ 2 , y, z: params.lean_p_d / 2 + d }, 1000).start();
            const_var.controls.target.copy({x: -(params.p_w + params.lean_p_w)/ 2 , y, z: params.lean_p_d / 2 });
            break;

        //Left lean back wall
        case "L_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w)/ 2, y, z: -params.lean_p_d / 2 - d }, 1000).start();
            const_var.controls.target.copy({x: -(params.p_w + params.lean_p_w)/ 2, y, z: -params.lean_p_d / 2});
            break;

        //Back lean side wall
        case "B_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: - params.p_d / 2 - params.leanB_p_w - (fvalue * params.leanB_p_d * 2) }, 1000).start();
            const_var.controls.target.set(x, y, z);
            break;

        //Back lean left wall
        case "B_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 - d, y, z: - (params.p_d + params.leanB_p_w)/ 2 }, 1000).start();
            const_var.controls.target.set(x, y, - (params.p_d + params.leanB_p_w)/ 2 );
            break;

        //Back lean right wall
        case "B_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_d / 2 + d, y, z: - (params.p_d + params.leanB_p_w)/ 2 }, 1000).start();
            const_var.controls.target.set(x, y, - (params.p_d + params.leanB_p_w)/ 2);
            break;


        //Front lean side wall
        case "F_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: params.p_d / 2 + params.leanF_p_w + (fvalue * params.leanF_p_d * 2) }, 1000).start();
            const_var.controls.target.set(x, y, z);
            break;

        //Front lean left wall
        case "F_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 - d, y, z: (params.p_d + params.leanF_p_w) / 2  }, 1000).start(); //x: z - d, y, z: x
            const_var.controls.target.set(x, y, (params.p_d + params.leanF_p_w) / 2);
            break;

        //Front lean right wall
        case "F_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_d / 2 + d, y, z: (params.p_d + params.leanF_p_w) / 2  }, 1000).start();
            const_var.controls.target.set(x, y, (params.p_d + params.leanF_p_w) / 2);
            break;

        //Right lean side wall
        case "R_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w + (fvalue * params.leanR_p_d * 2), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Right lean back wall
        case "R_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.lean_p_w) / 2, y, z: -params.leanR_p_d - d }, 1000).start();
            const_var.controls.target.copy({x: (params.p_w + params.lean_p_w) / 2, y, z});
            break;

        //Right Lean front wall
        case "R_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.lean_p_w) / 2, y, z: params.leanR_p_d / 2 + d }, 1000).start();
            const_var.controls.target.copy({x: (params.p_w + params.lean_p_w) / 2, y, z});
            break;

        //Left lean Storage Front wall
        case "L_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w)/ 2, y, z: params.lean_p_d / 2 + (fvalue * params.lean_p_w) }, 1000).start();
            const_var.controls.target.copy({x:-(params.p_w + params.lean_p_w)/ 2, y, z});
            break;

        //Left lean Storage Left wall
        case "L_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2) - params.lean_p_w - (fvalue * params.add_storage), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Left Lean Storage Right wall
        case "L_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w/2 + (fvalue * params.add_storage), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Right lean Storage Front wall
        case "R_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.leanR_p_w)/ 2, y, z: params.lean_p_d / 2 + d }, 1000).start();
            const_var.controls.target.copy({x: (params.p_w + params.leanR_p_w)/ 2, y, z});
            break;

        //Right lean Storage Left wall
        case "R_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 - (fvalue * params.add_storage_right), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Right Lean Storage Right wall
        case "R_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w + (fvalue * params.add_storage_right), y, z }, 1000).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //Back lean Storage Front wall
        case "B_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: -params.p_d / 2 - params.leanB_p_w - d }, 1000).start();
            const_var.controls.target.set(-z, y, x);
            break;

        //Back lean Storage Back wall
        case "B_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: z + d }, 1000).start();
            const_var.controls.target.set(x, y, z);
            break;

        //Back Lean Storage Left wall
        case "B_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_d / 2 + d, y, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).start();
            const_var.controls.target.set(x, y, -(params.p_d + params.leanB_p_w) / 2);
            break;

        //Front lean Storage Front wall
        case "F_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: params.p_d / 2 + params.leanF_p_w + d }, 1000).start();
            const_var.controls.target.set(x, y, z);
            break;

        //Front lean Storage Back wall
        case "F_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: z - d }, 1000).start();
            const_var.controls.target.set(x, y, z);
            break;

        //Front Lean Storage Right wall
        case "F_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_d / 2 + d, y, z: (params.p_d + params.leanF_p_w)/ 2  }, 1000).start();
            const_var.controls.target.set(x, y, (params.p_d + params.leanF_p_w)/ 2);

            break;

        default:
    }


    const_var.controls.update();
    
    animate()

    function animate() {
        requestAnimationFrame(animate)
        TWEEN.update()
    }
   
};


export const handleComponentPosition = (wallName,lean) =>{
    let filterRecord = const_var.entry_points.filter(data => data.component_wall_name == wallName);
        if(filterRecord.length>0)
        {
            let comName = const_var.scene.getObjectByName(filterRecord[0].component_name + filterRecord[0].uniqueId);
            let pos = comName.position.z;
            if(params.leantoAlignmentLeft=="2")
            {
                pos = (comName.position.z>0)?-comName.position.z:Math.abs(comName.position.z);
            }if(params.leantoAlignmentLeft=="3")
            {
                pos = (comName.position.z>0)?-comName.position.z:Math.abs(comName.position.z);
            }
            comName.position.set(comName.position.x, comName.position.y, pos);
            
        }
        
}


export const RemoveDoorComponent = (unique, compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_trim, is_edit,isBreezewayFrame,isChangePos) => {
    // console.log('giorgi- RemoveDoorCmp -> ', {unique, compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_trim, is_edit,isBreezewayFrame,isChangePos});
    let selectedCmpPosX = 0;
    let selectedCmpPosY = 0;
        if(is_edit && componentsize.entry_position!=undefined) {
            selectedCmpPosX = componentsize.entry_position.positionX;
            selectedCmpPosY = componentsize.entry_position.positionY;
        } else {
            const selectedComponent = const_var.newDoorsArray.find(s => s.uniqueId === unique)
            selectedCmpPosX = selectedComponent.positionX;
            selectedCmpPosY = selectedComponent.positionY;
        }

        for (var i = 0; i < const_var.newDoorsArray.length; i++) {
            if (const_var.newDoorsArray[i].uniqueId == unique) {
                const_var.removed_door_wallname = const_var.newDoorsArray[i].userData.wallName;
                const_var.removed_door = const_var.newDoorsArray.splice(i, 1)[0];
            }
        }

        const_var.entry_points.map((val, i) => {
            if (val.uniqueId == unique) {
                const_var.removed_door_entry_point = const_var.entry_points.splice(i, 1)[0];
                //const_var.entry_points = const_var.entry_points.splice(i,1)[0];
            }
        })
        // console.log("RemoveDoorComponent","RemoveDoorComponent111")
        cuBuilding.cP();
        //const_var.showComponentEditBox = false;
        params.wallPos = "Select";

        if (wall == undefined) wall = const_var.removed_door_wallname;
        let checkWallValue = const_var.checkWallClose[wall];
        var trimCalor = params.p_t_c.replace("#", "0x");
        if(checkWallValue == 'utility') {
          trimCalor = params.p_t_c.replace("#", "0x");
        } else {
          if (params[checkWallValue]=='Open') {
            trimCalor = '0x94989B';
          }
       }
        

        if (componentsize != undefined) {
            let prom = Promise.resolve(undefined);
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos) => {
                            prom = prom.then(async(res, rej) => {
                                const ans = await loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos);;
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos);
            
        }
}

export const removeAlltheComponent = (flag) => {
    // if (const_var.entry_points.length > 0) {
    if (const_var.entry_points.length > 0) {
        const_var.entry_points.map((val, i) => {
            // console.log(val,i,"const_var.entry_points")
            const_var.scene.remove(const_var.scene.getObjectByName(val.component_name + val.uniqueId));
            const_var.newDoorsArray.splice(i, 1);
            // const_var.entry_points.splice(i,1);
        })
        const_var.newDoorsArray = [];
        const_var.cupolas = [];
        const_var.b_d_g_b_O_cN = [];
        // cuBuilding.cP();
        const_var.showComponentEditBox = false;
    }
    // if (const_var.entry_points.length > 0) {
    if (const_var.entry_points.length > 0) {
        //for (var ii = 0; ii <= const_var.entry_points.length - 1; ii++) {
            const_var.newDoorsArray=[];
            const_var.entry_points = [];
            const_var.sum = 0;
            cuBuilding.cP();
        //}
    }
    if (const_var.cupolas.length > 0) {
        const_var.cupolas = [];
    }
 
}


export const RemovePorchComponent = (Val,newFlag) => { 
    let filterRecordFLF = const_var.entry_points.filter(data => data.component_wall_name == "F_L_F_W");
    let filterRecordBLS = const_var.entry_points.filter(data => data.component_wall_name == "B_L_S_W");
    let filterRecordLLL = const_var.entry_points.filter(data => data.component_wall_name == "L_L_L_W");
    let filterRecordRLR = const_var.entry_points.filter(data => data.component_wall_name == "R_L_R_W");
    let compWidth;

    if(filterRecordFLF.length > 0){
        // console.log(filterRecordFLF,"filterRecordFLF");
        for (let i = 0; i < filterRecordFLF.length; i++) {  
            if(filterRecordFLF[i].component_wall_name.includes("standard_door") || filterRecordFLF[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (Number(filterRecordFLF[i].name.split('x')[0]))*1
            }else{
                compWidth = (Number(filterRecordFLF[i].name.split('x')[0]))*0.084
            }
            if(params.add_left_front_lean_porch == false){
                if(filterRecordFLF[i].entry_position.x - (compWidth/2) < -(params.p_w/2)){
                   RemoveDoorComponent(filterRecordFLF[i].uniqueId, filterRecordFLF[i].component_name);
                }
                
            }

            if(params.add_right_front_lean_porch == false){
                if(filterRecordFLF[i].entry_position.x + (compWidth/2) > (params.p_w/2)){
                   RemoveDoorComponent(filterRecordFLF[i].uniqueId, filterRecordFLF[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordBLS.length > 0){
        for (let i = 0; i < filterRecordBLS.length; i++) {  
            if(filterRecordBLS[i].component_wall_name.includes("standard_door") || filterRecordBLS[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordBLS[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordBLS[i].name.split('x')[0])*0.084
            }
            if(params.add_left_back_lean_porch == false){
                if(filterRecordBLS[i].entry_position.x - (compWidth/2) < -(params.p_w/2)){
                   RemoveDoorComponent(filterRecordBLS[i].uniqueId, filterRecordBLS[i].component_name);
                }
                
            }

            if(params.add_right_back_lean_porch == false){
                if(filterRecordBLS[i].entry_position.x + (compWidth/2) > (params.p_w/2)){
                   RemoveDoorComponent(filterRecordBLS[i].uniqueId, filterRecordBLS[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordLLL.length > 0){
        for (let i = 0; i < filterRecordLLL.length; i++) {  
            if(filterRecordLLL[i].component_wall_name.includes("standard_door") || filterRecordLLL[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordLLL[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordLLL[i].name.split('x')[0])*0.084
            }
            if(params.add_left_back_lean_porch == false){
                if(filterRecordLLL[i].entry_position.z - (compWidth/2) < -(params.p_d/2)){
                   RemoveDoorComponent(filterRecordLLL[i].uniqueId, filterRecordLLL[i].component_name);
                }
                
            }

            if(params.add_left_front_lean_porch == false){
                if(filterRecordLLL[i].entry_position.z + (compWidth/2) > (params.p_d/2)){
                   RemoveDoorComponent(filterRecordLLL[i].uniqueId, filterRecordLLL[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordRLR.length > 0){
        for (let i = 0; i < filterRecordRLR.length; i++) {  
            if(filterRecordRLR[i].component_wall_name.includes("standard_door") || filterRecordRLR[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordRLR[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordRLR[i].name.split('x')[0])*0.084
            }
            if(params.add_right_back_lean_porch == false){
                if(filterRecordRLR[i].entry_position.z - (compWidth/2) < -(params.p_d/2)){
                   RemoveDoorComponent(filterRecordRLR[i].uniqueId, filterRecordRLR[i].component_name);
                }
                
            }

            if(params.add_right_front_lean_porch == false){
                if(filterRecordRLR[i].entry_position.z + (compWidth/2) > (params.p_d/2)){
                   RemoveDoorComponent(filterRecordRLR[i].uniqueId, filterRecordRLR[i].component_name);
                }
                
            }
        }
    }

}


export const addCupola = async (cupolaType,width,length,dimension,price,cupolaTypeId,cupolaName,position,isType) => {

    const validationVariables = cupolaValidation(length)
    const isAdd = validationVariables.isAdd;
    const positionZ = validationVariables.positionZ;
    const minLimitZ = validationVariables.minLimitZ;
    const maxLimitZ = validationVariables.maxLimitZ;
    const cupolaCount = isType === 'update' ? const_var.cupolaUniqueId : validationVariables.cupolaCount;
    const newArray = validationVariables.newArray;
    
    if (isAdd) {
        let tempArray = [...newArray];
        tempArray.push({
            name: "cupola" + cupolaCount,
            width,
            length,
            dimension,
            uniqueId: cupolaCount,
            userData: {
                cupolaTypeId: cupolaTypeId,
                compType: cupolaType,
                compName: cupolaName,
                editIconPos: new THREE.Vector3(0, 0, positionZ),
            },
            size: dimension,
            positionZ,
            minLimitZ,
            maxLimitZ,
            price,
        })

        const_var.isCupolaAdded = false;
        const_var.cupolas = [...tempArray];
        
        const_var.cupolaUniqueId = cupolaCount;
        const_var.cupolaEntries.push({'cupolaName':cupolaName,'cupolaType':cupolaType,'name': cupolaName, 'uniqueId': cupolaCount, 'cupola_price':price, 'dimension': dimension, 'width':width, 'length':length, 'position': {positionZ,minLimitZ,maxLimitZ},'cupolaId':cupolaTypeId,})
       
        store.dispatch(setPriceForCupola(true,const_var.cupolaUniqueId));
    } else {
        const_var.isCupolaAdded = false;
        const_var.isShowAlert = true;
        const_var.alertUsedFor = "noSpaceToAddCupola"
        store.dispatch(setPriceForCupola(false));
    }
}

export const updataOrRemoveCupola = (uniqueId,cupolaType,Width,length,dimension,price,cupolaTypeId,cupolaName,position,isType, oldCupolaWidth)=> {
    // if (isType === 'update') {
    //     let totalLength = 0, NumberOFcupolas = 0, cupolasZPosition = [];
    //     const_var.cupolas && const_var.cupolas.forEach((cupola) => {
    //         cupolasZPosition.push(cupola.positionZ)
    //         totalLength += cupola.width;
    //         NumberOFcupolas += 1;
    //     })  
        
    //     cupolasZPosition.sort((a, b) =>  a - b );
    //     if((totalLength + parseInt(Width)+ NumberOFcupolas + 1) - oldCupolaWidth >= params.p_d) {
    //         const_var.showCupolaEditBox = false;
    //         const_var.isShowAlert = true;
    //         const_var.alertUsedFor = "noSpaceToUpdateCupola";
    //         return
    //     } 
    // }

    const_var.scene.remove(const_var.scene.getObjectByName("cupola" + uniqueId));

    for (let i = 0; i < const_var.cupolas.length; i++) {
        if (const_var.cupolas[i].uniqueId == uniqueId) {
             const_var.cupolas.splice(i, 1);
        }
    }

    const_var.cupolaEntries.map((cupola, index) => {
        if (cupola.uniqueId == uniqueId) {
            const_var.cupolaEntries.splice(index, 1);
        }
    })

    let filterCupola = const_var.cupolaForMove.filter(c=> c.parent.uniqueId  == uniqueId)
    for (let ii = 0; ii <= filterCupola.length - 1; ii++) {
        if (filterCupola[ii].parent.uniqueId  == uniqueId) {
            for (let jj = 0; jj <= const_var.cupolaForMove.length - 1; jj++) {
                if (const_var.cupolaForMove[jj].parent.uniqueId  == uniqueId){
                    const_var.cupolaForMove.splice(jj, 1);
                }
            }
        }
    }

    cuBuilding.cP();
    if (Width) addCupola(cupolaType,Width,length,dimension,price,cupolaTypeId,cupolaName,position,isType);
}

export const handlCupolaPositionOnDimensionChange = (str) => {
    if (const_var.cupolaEntries.length > 0) {
            const cupolaEntries = JSON.parse(JSON.stringify(const_var.cupolaEntries))
            let mainPosArray = [], mainPos = 0 ,preCupolaWidth;
            for (let i = 0; i <= cupolaEntries.length - 1; i++) {
            let cupola = const_var.scene.getObjectByName(cupolaEntries[i].name);
                let zPosition = 0;
                if (str == "l") {
                    let cupolaWidth = cupolaEntries[i].width
                    if (mainPos == 0) {
                        zPosition = (-params.p_d / 2) + ((cupolaWidth/2) + 1);
                    } else {
                        zPosition = Number(mainPosArray[mainPos - 1]) + ((cupolaWidth/2)+(preCupolaWidth/2) + 1);
                    }
                    if (zPosition + (cupolaWidth / 2 ) + 1 >= params.p_d / 2 ) {
                        updataOrRemoveCupola(cupolaEntries[i].uniqueId,);
                        continue;
                    }
                    if (cupola != undefined) {
                        cupola.position.set(cupola.position.x, cupola.position.y, zPosition);
                        mainPosArray[mainPos] = zPosition;
                        mainPos++;
                        preCupolaWidth = cupolaWidth;
                    }
                } else {
                    if (cupola != undefined) {
                        cupola.position.set(-params.p_w / 2 - 0.1, cupola.position.y, cupola.position.z);
                    }
                }
            }
        
    }
}

export const removeAllCupolas = () => {
    if (const_var.cupolaEntries.length > 0) {
        const_var.cupolaEntries.map((cupola) => const_var.scene.remove(const_var.scene.getObjectByName(cupola.name)));
        const_var.cupolaEntries = [];
        const_var.cupolaForMove = [];
        const_var.cupolas = [];
        const_var.showCupolaEditBox = false;
        params.cupola = false;
        cuBuilding.cP();
    }
}

export const loadCupolaInEditMode = async (cupolaEntries,isOldQuotes,oldCupolasPrice,oldCupolasQty) => {
    // console.log({cupolaEntries,isOldQuotes});
    let prom = Promise.resolve(undefined);
    if (cupolaEntries !== undefined && cupolaEntries.length>0) {
        let prom = Promise.resolve();

        for (var i = 0; i < cupolaEntries.length; i++) {
            let length = cupolaEntries[i].length;
            let width = cupolaEntries[i].width;
            let cupolaType = cupolaEntries[i].cupolaType;
            let dimension = cupolaEntries[i].dimension;
            let cupola_price = cupolaEntries[i].cupola_price;
            let cupolaId = cupolaEntries[i].cupolaId;
            let cupolaName = cupolaEntries[i].cupolaName;
            let position = cupolaEntries[i].position;
            let mode = 'editmode'
            const newfuncforCupola = (cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, mode) => {
                prom = prom.then(async (res, rej) => {
                    const ans = await addCupola(cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, mode);
                });
            };
        
            newfuncforCupola(cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, 'editmode');
        }
    }
        
    if (isOldQuotes === "Yes"){
        let cupola,cupolaType,dimension,width,length,price,cupolaId,cupolaName;
        cupola = params.cupolaObj;
        cupolaId = cupola.id;
        dimension = cupola.structure;
        width = Number(dimension.split("x")[0]);
        length = Number(dimension.split("x")[1]);
        price = parseFloat(oldCupolasPrice) / Number(oldCupolasQty);
        cupolaType = "without_windows";
        cupolaName = "Without Windows";
    
        if (const_var.scene.getObjectByName("cupola1") == undefined) {
            await addCupola(cupolaType,width,length,dimension,price,cupolaId,cupolaName,const_var.cupolaPosition.cupola1Pos,'editmode');
        }

        if (params.cupolaQty == 2 || params.cupolaQty == 3){
            if (const_var.scene.getObjectByName("cupola2") == undefined){
                await addCupola(cupolaType,width,length,dimension,price,cupolaId,cupolaName,const_var.cupolaPosition.cupola2Pos,'editmode');
            } 
        }

        if(params.cupolaQty == 3){
            if (const_var.scene.getObjectByName("cupola3") == undefined) {
                await addCupola(cupolaType,width,length,dimension,price,cupolaId,cupolaName,const_var.cupolaPosition.cupola3Pos,'editmode');
            } 
        }
    }   
}
export function onResize() {
    let classData = document.getElementsByClassName("building-size");
    console.log(classData,"classData")
    const_var.camera.aspect = classData[0].clientWidth / classData[0].clientHeight;
    const_var.camera.updateProjectionMatrix();
    const_var.renderer.setSize(classData[0].clientWidth, classData[0].clientHeight);
}

function encodeSvgData(svgData) {
    let svgEncodedData = JSON.stringify(svgData);
    let startIndex = svgEncodedData.indexOf("<svg");
    svgEncodedData = svgEncodedData.substring(startIndex);    
    return svgEncodedData;
}

async function myFetch() {
    let floorPromise = new Promise(function(myResolve, myReject) {
        let count = 0;
        function check2DImage() {
            count += 1;
            if (const_var.layout2DMapId === const_var.generated2DMapId || count > 10) {
                myResolve();
            } else {
                setTimeout(check2DImage, 1000);
            }
        }
        setTimeout(check2DImage, 1000);
    });
    await floorPromise.then(function(val) {}, function(val) {});
        const_var.i_g_A_y2d = [];
        if (window.twoDMapReqPng) {
                if(const_var.twoDImageObj.length>0)
                {
                    const_var.twodImageData = [];
                    const_var.twoDImageObj.map((val,index)=>{
                        if(val.is_checked==true)
                        {
                            const_var.i_g_A_y2d.push({ "image": val.image, "image_name": "2D Layout1",'is_checked':val.is_checked });
                        }
                    })
                    const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                    const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                    
                }else{
                    const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                    const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                    
                }
            }else if (window.twoDMapAutoPng) {
                const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                
            } 
        const_var.twodImageData = const_var.twoDImageObj;
}
export const TsCeSot = async (Val, chkIndex,checkImg) => {
    controls.isCheckActiveTab = 'builtSize'
    params.activeWall = "c_b_f_w"
    params.is_translusant = false
    makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);
    if (Val == "print") {
        if(const_var.i_g_A_y.length == 0){
            let prom = Promise.resolve(undefined);
            if(checkImg==undefined)
                // ----> SE3-I2517 : multiple api call when creating quote.
                // {
                //     const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                //             prom = prom.then(async(res, rej) => {
                //                 const ans = await capturebuildingImages(Val, chkIndex);;
                //             });                        
                //         }
 
                //         newfuncforcapturebuildingImages(Val, chkIndex);
                //     }

                // ----> Since capturebuildingImages in not returning any promise
                {
                    const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                        prom = prom.then(() => {
                            capturebuildingImages(Val, chkIndex);               
                        });
                        };
                        
                    newfuncforcapturebuildingImages(Val, chkIndex);
                }
        }
        if (const_var.i_g_A_y.length == 4) {
            const_var.PrintAlertBox = true;
            const_var.PrintAlertBoxShowButton = true;
            store.dispatch(genratePrintImages(true));
            store.dispatch(showSaveLater("pdf",false))
            if(!const_var.isShowDownloadProgressBar) {
                store.dispatch(showDownloadProgressBar("show"))
            }
        }
    } else if( Val == "lead"){
        let prom = Promise.resolve();
        const_var.checkIval++;
        const_var.checkBlobImg = const_var.checkIval;
        if(checkImg==undefined)
            {
                const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                    prom = prom.then(() => {
                        capturebuildingImages(Val, chkIndex);  
                    });
                };
                
                newfuncforcapturebuildingImages(Val, chkIndex);
                
            }
        if (const_var.i_g_A_y.length == 1) {
            const_var.saveLatterModal =  false
            document.querySelector('#Savelater').classList.remove('overlay-container' , 'cu-modal-overlay')
 
            if(const_var.orderSaveForm == true){
                document.querySelector('#saveForm').classList.remove('d-none')
                document.querySelector('#saveForm').classList.add('overlay-container' , 'gather-customer-information')    
            }else{
                document.querySelector('#saveForm').classList.add('d-none')    
                store.dispatch(ShowHideCheckout())
            }
            console.log(const_var.saveLatterModal,const_var.isShowConfigBox,"const_var.saveLatterModal")
 
        }
    }else {
        if (const_var.checkCaptuareImage == true) {
            if (const_var.two_d_layuot.is_active == 1 && const_var.crmSetting.is_module_name != "inventory") {
                await myFetch().then((msg) => {
                    //console.log(msg);
                });
            }

            if (const_var.i_g_A_y.length > 0) {
                const_var.CallApionAction = true;
                let settingData = const_var.crmSetting;
                for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                    if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout") {
                        const_var.i_g_A_y.splice(i, 1);
                    }
                    if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked == false) {
                        const_var.i_g_A_y.splice(i, 1);
                    }
                }
                if (const_var.two_d_layuot.is_active == 1 && const_var.i_g_A_y2d != undefined && const_var.i_g_A_y2d.length > 0) {
                    if (const_var.crmSetting.is_module_name == "quote" && const_var.two_d_layuot.include_in_quote == 1) {
                        const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                    }
                    if (const_var.crmSetting.is_module_name == "order" && const_var.two_d_layuot.include_in_order == 1) {
                        const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                    }
                }
                let apiData = { api_token: settingData.api_token, module: "quote", pdf_images: const_var.i_g_A_y };
    
                return axios.post(const_var.crmSetting.api_post_url + "/api/save-oq-image", apiData).then(function (response) {    

                    // if (response.data.status == true) {
                    //     const_var.post_data["pdf_images"] = response.data.id;
                    //     if (const_var.loginSession == true) {
                    //         store.dispatch(SendBuildingDatatoServer());
                    //     }else if (const_var.isPublicEdit == true) {
                    //         store.dispatch(SendBuildingDatatoPublicServer());
                    //     } else {
                    //         const_var.showProcessLoaderchk = false;
                            
                    //         if(const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.saveLatterModal == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.post_data && const_var.post_data.full_name != undefined && const_var.post_data.full_name != '' && const_var.showStateOnly != true){
                    //             store.dispatch({
                    //                 type: "onQuoteSubmit",
                    //             });
                    //             if(const_var.checkValidate==false){
                    //                store.dispatch(onQuoteSubmitApi());
                    //             }
                    //         }else{
                    //             var element = document.getElementsByClassName("spinner-active")[0];
                    //             element?.classList.remove("spinner-active");
                    //         }
                    //     }
                    // }
                    if (response.data.status == true) {

                        const_var.post_data["pdf_images"] = response.data.id;
                        if (const_var.loginSession == true) {
                            store.dispatch(SendBuildingDatatoServer());
                        } else {
                            const_var.showProcessLoaderchk = false;
                            var element = document.getElementsByClassName("spinner-active")[0];
                            element?.classList.remove("spinner-active");
                        }
                        const_var.saveLatterModal = false
                        document.querySelector('#Savelater').classList.remove('overlay-container' , 'cu-modal-overlay')

                        if(const_var.orderSaveForm == true){
                            document.querySelector('#saveForm').classList.remove('d-none')
                            document.querySelector('#saveForm').classList.add('overlay-container' , 'gather-customer-information')    
                        }else{
                            document.querySelector('#saveForm').classList.add('d-none')    
                            store.dispatch(ShowHideCheckout())
                        }
                        const_var.saveLatterModal = false
                        console.log(const_var.saveLatterModal,const_var.isShowConfigBox,"const_var.saveLatterModal",response,const_var.orderSaveForm)
                    }
                });
            }
        } else {
                if(const_var.i_g_A_y.length == 0){
                   
                    let prom = Promise.resolve();
                    // ----> SE3-I2517 : multiple api call when creating quote.

                    // {
                    //     const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                    //             prom = prom.then(async(res, rej) => {
                    //                 const ans = await capturebuildingImages(Val, chkIndex);;
                    //         });                        
                    //     }
     
                    //     newfuncforcapturebuildingImages(Val, chkIndex);
                    // }

                    // ----> Since capturebuildingImages in not returning any promise
                    
                    if(checkImg==undefined)
                    {
                        const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                            prom = prom.then(() => {
                                capturebuildingImages(Val, chkIndex);  
                            });
                        };
                        
                        newfuncforcapturebuildingImages(Val, chkIndex);
                        
                    }
                    //capturebuildingImages()
                }
                if (const_var.two_d_layuot.is_active == 1 && const_var.crmSetting.is_module_name != "inventory") {
                    await myFetch().then((msg) => {
                            //console.log(msg);
                    });
                }
                // if (const_var.i_g_A_y.length == 4) {
                // ----> SE3-I2517 : multiple api call when creating quote.
                // As the save-oq-image api calling was happening twice, we have to add one moew condition (const_var.checkCaptuareImage == false)
                // Since the "capturebuildingImages" function is also calling function TsCeSot internally and making checkCaptuareImage = true.
                if (const_var.i_g_A_y.length == 4 && const_var.checkCaptuareImage == false) {

                    const_var.CallApionAction = true;
                    let settingData = const_var.crmSetting;
                    for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                        if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout") {
                            const_var.i_g_A_y.splice(i, 1);
                        }
                        if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked == false) {
                            const_var.i_g_A_y.splice(i, 1);
                        }
                    }
                    if (const_var.two_d_layuot.is_active == 1 && const_var.i_g_A_y2d != undefined && const_var.i_g_A_y2d.length > 0) {
                       
                        if (const_var.crmSetting.is_module_name == "quote" && const_var.two_d_layuot.include_in_quote == 1) {
                            const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                        }
                        if (const_var.crmSetting.is_module_name == "order" && const_var.two_d_layuot.include_in_order == 1) {
                            const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                        }
                    }
                    if(const_var.i_g_A_y.length>0)
                    {
                        for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                            if (const_var.i_g_A_y[i]==null) {
                                const_var.i_g_A_y.splice(i, 1);
                            }
                        }
                    }
                    let apiData = {
                        api_token: settingData.api_token,
                        module: "quote",
                        pdf_images: const_var.i_g_A_y,
                    };


                    return axios.post(const_var.crmSetting.api_post_url + "/api/save-oq-image", apiData).then(function (response) {
                                 
                        if (response.data.status == true) {
                            const_var.post_data["pdf_images"] = response.data.id;
                            if (const_var.loginSession == true) {
                                store.dispatch(SendBuildingDatatoServer());
                            }else if (const_var.isPublicEdit == true) {
                                store.dispatch(SendBuildingDatatoPublicServer());
                            } else {
                                const_var.showProcessLoaderchk = false;
                                var element = document.getElementsByClassName("spinner-active")[0];
                                element?.classList.remove("spinner-active");
                                // if(const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.saveLatterModal == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.post_data && const_var.post_data.full_name != undefined && const_var.post_data.full_name != '' && const_var.showStateOnly != true){
                                //     store.dispatch({
                                //         type: "onQuoteSubmit",
                                //     });
                                //     if(const_var.checkValidate==false){
                                //        store.dispatch(onQuoteSubmitApi());
                                //     }
                                // }
                            }
                            const_var.checkIval = 0;
                            const_var.i_g_A_y = [];

                            const_var.saveLatterModal = false
                            document.querySelector('#Savelater').classList.remove('overlay-container' , 'cu-modal-overlay')

                            if(const_var.orderSaveForm == true){
                                document.querySelector('#saveForm').classList.remove('d-none')
                                document.querySelector('#saveForm').classList.add('overlay-container' , 'gather-customer-information')    
                            }else{
                                document.querySelector('#saveForm').classList.add('d-none')    
                                store.dispatch(ShowHideCheckout())
                            }
                            const_var.saveLatterModal = false
                            console.log(const_var.saveLatterModal,const_var.isShowConfigBox,"const_var.saveLatterModal",response,const_var.orderSaveForm)
                        }
                    });
                }

        }
    }
};

 export const capturebuildingImages = (Val, chkIndex) =>{
    const d = 25 * 5;
    let positions = [
        { x: params.p_w / 2 + (params.add_right_lean? params.leanR_p_w : 0) + d /4 * 3, y: params.p_h / 2, z: params.p_d / 2 + (params.add_front_lean? params.leanF_p_w : 0) + (params.add_left_lean? params.lean_p_w : 0) + d },
        { x: (params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
        { x: 0, y: params.p_h / 2, z: -(params.p_d / 2 + Math.max(params.add_back_lean ? params.leanB_p_w : 0, params.add_left_lean ? params.lean_p_w : 0, params.add_right_lean ? params.leanR_p_w : 0) + d)},
        { x: -(params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
        // { x: 0, y: (params.p_d / 4 * 3 + (( params.p_r_p / 12)*(params.p_w / 2))) * 2 +  Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d, z: 0 },
    ];
    if(Val !=undefined && Val == "lead"){
       positions = [
            { x: params.p_w / 2 + (params.add_right_lean? params.leanR_p_w : 0) + d /4 * 3, y: params.p_h / 2, z: params.p_d / 2 + (params.add_front_lean? params.leanF_p_w : 0) + (params.add_left_lean? params.lean_p_w : 0) + d }
        ]
    }
    let i = 0;
    const recursive = () => {
        const camera = const_var.camera;
        const controls = const_var.controls;
        const targetPosition = positions[i]
        // console.log(i,positions,"capturebuildingImages")
        if(i>positions.length - 1) {
            store.dispatch(isAllCaptured(true))
            const_var.activeTab = "buildingtypetab"
            TsCeSot(Val, chkIndex,true)
            i = 0;
            return;
        }
        
        new TWEEN.Tween(camera.position)
        .to(targetPosition, 300)
        .onUpdate(() => {
            controls.target.set(0, params.p_h / 2, 0);
            controls.update(); // Make sure controls are updated with the new camera position
        })
        .onComplete(() => {
            store.dispatch(captureBlobImages());
            i++
            setTimeout(() => {
                recursive()
            }, 100);
        })
        .start();
    } 
    recursive()
 }

export default componentReducer;
